import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watchEffect } from "vue";
import API from "@/api";
import {
  deleteAppUsingPost,
  doAppReviewUsingPost,
  listAppByPageUsingPost,
  updateAppUsingPost,
} from "@/api/appController";
import message from "@arco-design/web-vue/es/message";
import dayjs from "dayjs";
import {
  APP_SCORING_STRATEGY_ENUM,
  APP_SCORING_STRATEGY_MAP,
  APP_TYPE_ENUM,
  APP_TYPE_MAP,
  REVIEW_STATUS_ENUM,
  REVIEW_STATUS_MAP,
} from "@/constant/appEnum";
import PictureUpload from "@/components/picture/PictureUpload.vue";
import router from "@/router";
//初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminAppPage',
  setup(__props) {

const initParams = {
  current: 1,
  pageSize: 10,
  sortField: "createTime",
  sortOrder: "descend",
};
//搜索参数
const formParams = ref<API.AppQueryRequest>({
  ...initParams,
});
//传递参数
const searchParams = ref<API.AppQueryRequest>({});
//数据
const dataList = ref<API.App[]>([]);
//总值
const total = ref<number>(0);
const loading = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  loading.value = true;
  const response = await listAppByPageUsingPost(searchParams.value);
  if (response.data.code === 0) {
    dataList.value = response.data.data?.records || [];
    total.value = response.data.data?.total || 0;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 搜索
 */
const search = () => {
  searchParams.value = { ...initParams, ...formParams.value };
};

/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 当分页变化时，改变搜索条件，触发数据加载
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 审核
 */
const doReview = async (id: number, reviewStatus: number, msg: string) => {
  const res = await doAppReviewUsingPost({
    id,
    reviewStatus,
    reviewMessage: msg,
  });
  if (res.data.code === 0) {
    await loadData();
  } else {
    message.error("审核失败，" + res.data.message);
  }
};
/**
 * 更新
 */
const updateVisible = ref(false);
const updateDate = ref<API.App>({});
const doUpdate = (record: API.App) => {
  updateVisible.value = true;
  updateDate.value = { ...record };
};
const updateSubmit = async () => {
  const res = await updateAppUsingPost({
    ...updateDate.value,
  } as API.AppUpdateRequest);
  if (res.data.code === 0) {
    message.success("修改成功");
    await loadData();
    updateVisible.value = false;
  } else {
    message.error("修改失败，" + res.data.message);
  }
  updateDate.value = {};
};

/**
 * 删除
 */
const doDelete = async (id: number) => {
  const res = await deleteAppUsingPost({ id });
  if (res.data.code === 0) {
    loadData();
  } else {
    message.error("删除失败，" + res.data.message);
  }
};

const columns = [
  {
    title: "ID",
    dataIndex: "id",
  },
  {
    title: "用户ID",
    dataIndex: "userId",
  },
  {
    title: "应用名称",
    dataIndex: "appName",
  },
  {
    title: "应用描述",
    dataIndex: "appDesc",
  },
  {
    title: "应用图标",
    dataIndex: "appIcon",
    slotName: "appIcon",
  },
  {
    title: "应用类型",
    dataIndex: "appType",
    slotName: "appType",
  },
  {
    title: "评分策略",
    dataIndex: "scoringStrategy",
    slotName: "scoringStrategy",
  },
  {
    title: "审核状态",
    dataIndex: "reviewStatus",
    slotName: "reviewStatus",
  },
  {
    title: "审核信息",
    dataIndex: "reviewMessage",
  },
  {
    title: "审核人ID",
    dataIndex: "reviewerId",
  },
  {
    title: "审核时间",
    dataIndex: "reviewTime",
    slotName: "reviewTime",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    dataIndex: "updateTime",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
  {
    title: "标签",
    slotName: "tags",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      model: formParams.value,
      layout: "inline",
      style: {"margin":"0 0 10px auto"},
      "label-align": "left",
      "auto-label-width": "",
      onSubmit: search
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "id",
          label: "ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formParams.value.id) = $event)),
              placeholder: "请输入ID...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userId",
          label: "用户ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.userId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formParams.value.userId) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appName",
          label: "应用名："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.appName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formParams.value.appName) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appDesc",
          label: "应用描述："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.appDesc,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formParams.value.appDesc) = $event)),
              placeholder: "请输入...",
              "allow-clear": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "appType",
          label: "应用类型："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: formParams.value.appType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formParams.value.appType) = $event)),
              placeholder: "请输入...",
              "allow-clear": "",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  value: _unref(APP_TYPE_ENUM).SCORE
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)["0"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(APP_TYPE_ENUM).TEST
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)["1"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "scoringStrategy",
          label: "评分策略："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: formParams.value.scoringStrategy,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formParams.value.scoringStrategy) = $event)),
              placeholder: "请输入...",
              "allow-clear": "",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  value: _unref(APP_SCORING_STRATEGY_ENUM).CUSTOM
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)["0"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(APP_SCORING_STRATEGY_ENUM).AI
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)["1"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "reviewStatus",
          label: "审核状态："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              modelValue: formParams.value.reviewStatus,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formParams.value.reviewStatus) = $event)),
              placeholder: "请输入...",
              "allow-clear": "",
              style: {"width":"100px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, {
                  value: _unref(REVIEW_STATUS_ENUM).REVIEWING
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)["0"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(REVIEW_STATUS_ENUM).PASS
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)["1"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_a_option, {
                  value: _unref(REVIEW_STATUS_ENUM).REJECT
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)["2"]), 1)
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "reviewerId",
          label: "审核ID："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: formParams.value.reviewerId,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formParams.value.reviewerId) = $event)),
              placeholder: "请输入..."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("搜索 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_space, { size: "large" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push('/add/app'))),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("添加应用 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortOrder,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formParams.value.sortOrder) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "ascend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("正序")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "descend" }, {
                  default: _withCtx(() => [
                    _createTextVNode("倒序")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { label: "排序字段：" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_group, {
              modelValue: formParams.value.sortField,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formParams.value.sortField) = $event)),
              type: "button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio, { value: "createTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("创建时间")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_radio, { value: "updateTime" }, {
                  default: _withCtx(() => [
                    _createTextVNode("更新时间")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: updateVisible.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((updateVisible).value = $event)),
      footer: false
    }, {
      title: _withCtx(() => [
        _createTextVNode(" 修改题目")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: updateDate.value }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "appName",
              label: "应用名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: updateDate.value.appName,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((updateDate.value.appName) = $event)),
                  placeholder: "请输入应用名称..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "appDesc",
              label: "应用描述"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: updateDate.value.appDesc,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((updateDate.value.appDesc) = $event)),
                  placeholder: "请输入应用描述..."
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "appIcon",
              label: "应用图标",
              tooltip: "输入图标链接"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, { size: "large" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_a_image, {
                      src: updateDate.value.appIcon,
                      width: "80px"
                    }, null, 8, ["src"]), [
                      [_vShow, updateDate.value.appIcon]
                    ]),
                    _createVNode(PictureUpload, {
                      biz: "app_icon",
                      value: updateDate.value.appIcon,
                      onChange: (url) => (updateDate.value.appIcon = url)
                    }, null, 8, ["value", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "appType",
              label: "应用类型",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  modelValue: updateDate.value.appType,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((updateDate.value.appType) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      value: Number(1)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[1]), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_a_radio, {
                      value: Number(0),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (updateDate.value.scoringStrategy = 0))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[0]), 1)
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "scoringStrategy",
              label: "评分策略",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  modelValue: updateDate.value.scoringStrategy,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((updateDate.value.scoringStrategy) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, {
                      value: Number(0)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[0]), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _withDirectives(_createVNode(_component_a_radio, {
                      value: Number(1)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[1]), 1)
                      ]),
                      _: 1
                    }, 8, ["value"]), [
                      [_vShow, updateDate.value.appType == 1]
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_popconfirm, {
                  content: "确定要删除吗",
                  onOk: updateSubmit
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 修改")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
      showTotal: true,
      pageSize: searchParams.value.pageSize,
      current: searchParams.value.current,
      total: total.value,
    },
      stripe: true,
      bordered: { cell: true },
      loading: loading.value,
      onPageChange: onPageChange
    }, {
      appIcon: _withCtx(({ record }) => [
        _createVNode(_component_a_image, {
          width: "64",
          src: record.appIcon
        }, null, 8, ["src"])
      ]),
      appType: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(APP_TYPE_MAP)[record.appType]), 1)
      ]),
      scoringStrategy: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(APP_SCORING_STRATEGY_MAP)[record.scoringStrategy]), 1)
      ]),
      reviewStatus: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(REVIEW_STATUS_MAP)[record.reviewStatus]), 1)
      ]),
      reviewTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.reviewTime).format("YYYY-MM-DD")), 1)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (record.reviewStatus !== _unref(REVIEW_STATUS_ENUM).PASS)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "outline",
                  onClick: ($event: any) => (doReview(record.id, _unref(REVIEW_STATUS_ENUM).PASS, '符合上架要求')),
                  status: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 通过 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (record.reviewStatus !== _unref(REVIEW_STATUS_ENUM).REJECT)
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  type: "outline",
                  status: "warning",
                  onClick: ($event: any) => (
            doReview(record.id, _unref(REVIEW_STATUS_ENUM).REJECT, '不符合上架要求')
          )
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 拒绝 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (doUpdate(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_popconfirm, {
              content: "确定要删除吗",
              onOk: ($event: any) => (doDelete(record.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { status: "danger" }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"])
          ]),
          _: 2
        }, 1024)
      ]),
      tags: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination", "loading"])
  ], 64))
}
}

})